import { render } from "./lei-details.vue?vue&type=template&id=1017345c&scoped=true&ts=true"
import script from "./lei-details.vue?vue&type=script&lang=ts"
export * from "./lei-details.vue?vue&type=script&lang=ts"

import "./lei-details.vue?vue&type=style&index=0&id=1017345c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1017345c"]])

export default __exports__